const auth = require('./auth.actions');
const persistedMultiCart = require('./persisted-multi-cart.actions');
const checkout = require('./checkout.actions');

module.exports = { auth, persistedMultiCart, checkout };
